import { render, staticRenderFns } from "./CardRecent.vue?vue&type=template&id=9fd101b0&scoped=true&"
import script from "./CardRecent.vue?vue&type=script&lang=js&"
export * from "./CardRecent.vue?vue&type=script&lang=js&"
import style0 from "./CardRecent.vue?vue&type=style&index=0&id=9fd101b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd101b0",
  null
  
)

export default component.exports